var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 40.313,
    viewBox: "0 0 39 40.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#003d5b;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.236 0.318)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 39,
    height: 40,
    transform: "translate(0.236 -0.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.351,23.663A6.94,6.94,0,0,0,23.3,16.711a7.154,7.154,0,0,0-6.953-7.2A6.94,6.94,0,0,0,9.4,16.462,7.329,7.329,0,0,0,16.351,23.663ZM4.681,4.792A16.5,16.5,0,0,1,28.021,28.132L16.351,39.8,4.681,28.132A16.955,16.955,0,0,1,4.681,4.792Z",
    transform: "translate(1.456 0.192)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/mapMarker.be40308679e83a6161e7d8908148dd4c.svg";
export { ForwardRef as ReactComponent };